import { useLayoutLanguage } from '../context/LayoutLanguageContext';
import { useAppNavigation } from "../hooks/useAppNavigation";


const UnauthorizedPage = () => {
    
  const { layoutT } = useLayoutLanguage();

  const { goToApplications } = useAppNavigation();

  const goToMyApplications = () => {
    setTimeout(() => {
      goToApplications();
    }, 50);
  };

  return (
    <div className="form-q error-page" style={{ textAlign: "center" }}>
       <h1>{layoutT('unauthorized_title')}</h1>
      <p className="mb-4">{layoutT('unauthorized_message')}</p>

      <button onClick={goToMyApplications} className='btn-purple'>
        {layoutT('return_to_applications')}
      </button>

    </div>
  );
}

export default UnauthorizedPage;